// src/components/EquipmentManager/RatingBreakdown.jsx

import React from 'react';
import PropTypes from 'prop-types';
import StarRating from '../common/StarRating';
import styles from './RatingBreakdown.module.css';

const RatingBreakdown = ({ ratingSummary }) => {
  if (!ratingSummary || ratingSummary.totalReviews === 0) {
    return (
      <div className={styles.noRatings}>
        <p>No ratings yet. Be the first to review!</p>
      </div>
    );
  }
  
  const getPercentage = (count, total) => {
    if (total === 0) return 0;
    return Math.round((count / total) * 100);
  };
  
  return (
    <div className={styles.ratingBreakdown}>
      {/* Overall Rating */}
      <div className={styles.overallRating}>
        <div className={styles.ratingNumber}>
          {ratingSummary.averageRating?.toFixed(1) || '0.0'}
        </div>
        <StarRating 
          rating={ratingSummary.averageRating || 0} 
          size="large"
        />
        <div className={styles.totalReviews}>
          Based on {ratingSummary.totalReviews} review{ratingSummary.totalReviews !== 1 ? 's' : ''}
        </div>
      </div>
      
      {/* Rating Breakdown Bars */}
      <div className={styles.breakdownBars}>
        {[5, 4, 3, 2, 1].map(rating => {
          const count = ratingSummary.ratingBreakdown?.[rating] || 0;
          const percentage = getPercentage(count, ratingSummary.totalReviews);
          
          return (
            <div key={rating} className={styles.ratingRow}>
              <span className={styles.ratingLabel}>{rating} ⭐</span>
              <div className={styles.barContainer}>
                <div 
                  className={styles.barFill}
                  style={{ width: `${percentage}%` }}
                  data-percentage={percentage}
                />
              </div>
              <span className={styles.ratingCount}>{count}</span>
              <span className={styles.ratingPercent}>{percentage}%</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

RatingBreakdown.propTypes = {
  ratingSummary: PropTypes.shape({
    averageRating: PropTypes.number,
    totalReviews: PropTypes.number,
    ratingBreakdown: PropTypes.object
  })
};

export default RatingBreakdown;

